// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory} from "@app/shared";
import { CategoryModel, DepartmentPropertyDto, DocumentModel } from "@app/catalog";

export class DepartmentPropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public code: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public categories: WritableSignal<CategoryModel[]>;
    public documents: WritableSignal<DocumentModel[]>;
    
    public hasImageError: WritableSignal<boolean>;


    constructor()
    {
        this.name = signal<string>(null);
        this.code = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.categories = signal<CategoryModel[]>([]);
        this.documents = signal<DocumentModel[]>([]);
        this.hasImageError = signal<boolean>(false);
    }

    public handleImageError() {
        this.hasImageError.set(true);
    }

    public static fromDto(dto: DepartmentPropertyDto)
    {
        let department = new DepartmentPropertyModel();

        department.id = dto.id;
        department.name.set(dto.name);
        department.code.set(dto.code);
        department.thumbnailUrl.set(dto.thumbnailUrl);
        if (dto.documents?.length) {
            department.documents.set(dto.documents.map(doc => DocumentModel.fromDto(doc)));
        } else {
            department.documents.set([]);
        }
        //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
        department.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)));
        
        return department;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<DepartmentPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<DepartmentPropertyModel>(this.name, this.id, this, selected);

}
